import React, { useState } from "react";
import { BCAddVerbruikRequest } from "../../../Interfaces/BCAddVerbruikRequest";
import { BCItem } from "../../../Interfaces/BCItem";
import { Service } from "../../../Interfaces/Service";
import { DataService } from "../../../Services/DataService";
import { Form, Input, InputNumber, Modal, Select } from "antd";

type Props = {
    onOk: (request: BCAddVerbruikRequest) => Promise<void>;
    onCancel: () => void;
    isOpen: boolean;
    isLoading: boolean;
    orderNo: string;
    serviceItemLineNo: string;
}

const AddVerbruikModal = (props: Props) => {

    const [form] = Form.useForm();

    const [items, setItems] = useState<Service<BCItem[]>>({ status: "loading" });

    const [disabled, setDisabled] = useState<boolean>(true);

    React.useEffect(() => {
        DataService.getItems().then(res => {
            setItems(res);
        }).catch(err => {
            setItems({ status: "error", error: err })
        });
    }, []);

    return (
        <Modal
            //className="astena-modal"
            open={props.isOpen}
            title={"Verbruik toevoegen"}
            okText="Toevoegen"
            confirmLoading={props.isLoading}
            cancelText="Annuleren"
            onCancel={props.onCancel}
            width={"70vw"}
            onOk={() => {
                form
                    .validateFields()
                    .then((values) => {
                        props.onOk({
                            itemNo: values.itemNo,
                            quantity: values.quantity,
                            description: values.description,
                            orderNo: props.orderNo,
                            serviceItemLineNo: Number(props.serviceItemLineNo)
                        })
                            .then(() => form.resetFields());

                    })
                    .catch((info) => {
                        //console.log('Validate Failed:', info);
                    });
            }}
        >
            <Form
                form={form}
                layout="vertical"
                name="form_in_modal"
                style={{ padding: 20 }}
            >
                <Form.Item
                    name="itemNo"
                    label="Artikel"
                    rules={[{ required: true, message: 'Artikel verplicht' }]}
                >
                    <Select
                        showSearch
                        onChange={(value) => {
                            if (items.status === "loaded") {
                                let item = items.payload.find(x => x.no == value);
                                if (item)
                                    form.setFieldValue("description", item.description);
                            }

                            if (value == "MAT") {
                                setDisabled(false);
                            } else setDisabled(true);
                        }}
                        filterOption={(inputValue, option) => {
                            var found = option!.label.toLowerCase().includes(inputValue.toLowerCase());
                            if(!found){
                                if(items.status === "loaded"){
                                    var foundItem = items.payload.find(x => x.no == option!.value);
                                    if(foundItem){
                                        var found = foundItem.itemCategoryCode.toLowerCase().includes(inputValue.toLowerCase());
                                    }
                                }
                            }
                            return found;

                        }}
                        options={items.status === "loaded" ? items.payload.map(x => {
                            return {
                                label: x.description + ` (${x.no})`,
                                value: x.no
                            }
                        }) : []} placeholder="Kies artikel" />

                </Form.Item>
                <Form.Item
                    name="description"
                    label="Omschrijving"
                    rules={[{ required: true, message: 'Omschrijving verplicht' }]}
                >
                    <Input disabled={disabled} />
                </Form.Item>
                <Form.Item
                    name="quantity"
                    label="Aantal"
                    rules={[{ required: true, message: 'Aantal verplicht' }]}
                >
                    <InputNumber defaultValue={0} min={0} />
                </Form.Item>
            </Form>
        </Modal>

    );
};

export default AddVerbruikModal;